import {Directive, HostBinding, Input} from '@angular/core';

@Directive({
    selector: 'img[default]',
    host: {
        '(error)': 'updateUrl()',
        '(load)': 'load()',
        '[src]': 'src'
    },
    standalone: false
})
export class PreloadImageDirective {
  @Input() src: string;
  @Input() default: string;
  @Input() class: string;
  @HostBinding('class') className;

  constructor() { }

  updateUrl() {
    this.src = this.default;
  }
  load() {
    this.className = this.class + ' image-loaded';
  }

}
